import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AppLayout from 'components/core/AppLayout';

export const renderNestedLayoutRoutes = (routesList) => {
  if (!routesList) return null;
  return routesList.map((routeEntry, index) => {
    const { component: RouteComponent, path, frameSrc, exact } = routeEntry;

    if (Array.isArray(RouteComponent)) {
      return (
        <Route key={index} exact={!!exact} path={path}>
          <Switch>{renderNestedLayoutRoutes(RouteComponent)}</Switch>
        </Route>
      );
    }
    return (
      <Route key={index} path={path} exact={!!exact}>
        <AppLayout>
          {frameSrc ? (
            <RouteComponent frameSrc={frameSrc} />
          ) : (
            <RouteComponent />
          )}
        </AppLayout>
      </Route>
    );
  });
};

// Replace the path like /Customers/:adfitNo with param { adfitNo: '1234' }
export const replacePathParams = (path, params) => {
  if (!params || !path) return path;
  return Object.keys(params).reduce(
    (accumulator, currentValue) =>
      accumulator.replace(`:${currentValue}`, params[currentValue]),
    path
  );
};
